import { memo, useEffect } from 'react';

import { LoadingTexto, LoadingTextoProps } from 'view/component/Tipografia/Texto';
import { PessoasSelector } from 'store/Pessoas/Pessoas.selector';
import { useDispatch, useSelector } from 'react-redux';
import { PessoasAction } from 'store/Pessoas/Pessoas.action';
import Pessoa from 'model/pessoa/Pessoa';


interface NomePessoaProps extends LoadingTextoProps {
  idInstitucional: string;
}

export const NomePessoa = memo<NomePessoaProps>(({idInstitucional, width, ...props}) => {
  const pessoa = useSelector(PessoasSelector.pessoa(idInstitucional));
  const dispatch = useDispatch();

  useEffect(() => {
    if (pessoa === undefined) {
      dispatch(PessoasAction.carregar(idInstitucional))
    }
  }, [idInstitucional, pessoa, dispatch]);
  
  return <NomePessoaConteudo {...props} pessoa={pessoa} />
});


interface NomePessoaConteudoProps extends LoadingTextoProps {
  pessoa?: Pessoa;
}

export const NomePessoaConteudo = memo<NomePessoaConteudoProps>(({pessoa, width, ...props}) => {
  if (pessoa === undefined) {
    return <LoadingTexto {...props} width={width ?? 120} />
  } else {
    return <>{pessoa.nome}</>
  }
});